/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Zoom_In_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Zoom In" |
*
* @param {Timeline_Zoom_In_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_zoom_in_aria_label = /** @type {((inputs?: Timeline_Zoom_In_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Zoom_In_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Zoomer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergrößern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ingrandisci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличить масштаб")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dar un golpe de zoom")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("放大")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズームイン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम इन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ampliar")
	return /** @type {LocalizedString} */ ("Zoom In")
});